import { useAppSelector } from "../../store/hooks.ts";

import ReportsDatePicker from "./reportsdatepicker/ReportsDatePicker.tsx";
import { selectReportType } from "../../store/slices/reportsSlice.ts";

import GenderAgeChart from "./charts/AgeSexChart.tsx";
import MonthlyIncomeChart from "./charts/MonthlyIncomeChart.tsx";
import SpecialityChart from "./charts/SpecialityChart.tsx";
import AveragePerSessionChart from "./charts/AveragePerSessionChart.tsx";

const Reports = () => {
	const reportType = useAppSelector(selectReportType);
	return (
		<div>
			<ReportsDatePicker />
			{reportType === "ageAndGender" && <GenderAgeChart />}{" "}
			{reportType === "monthlyIncome" && <MonthlyIncomeChart />}{" "}
			{reportType === "speciality" && <SpecialityChart />}{" "}
			{reportType === "averagePerSession" && <AveragePerSessionChart />}
		</div>
	);
};

export default Reports;
